import { WidthContainer } from '@pata-app/ui-document';
import { Button } from '@pata-app/ui-form';
import { Image } from '@pata-app/ui-media';

import React from 'react';

import SectionContainer from '../../../../components/sectionContainer/sectionContainer';
import { TextWithHighlight } from '../../../../components/textWithHighlight/textWithHighlight';
import { getEnv } from '../../../../lib/utils/getEnv';
import { ActionContainer } from '../heroSection/heroSection.styled';
import {
  ProcessesContainer,
  SignUpProcessContainer,
  SignUpProcessContent,
  SignUpProcessTitleContainer,
} from './signUpProcess.styled';

const { VITE_PARTNERS_BASE_URL, VITE_CDN_BASE_URL } = getEnv();

const SignUpProcessTitle = () => {
  return (
    <SignUpProcessTitleContainer>
      <TextWithHighlight>
        <h2>
          Join the top UK pet groomers enjoying a free and easy-to-use
          <strong> booking management platform</strong>
        </h2>
      </TextWithHighlight>

      <p>
        New grooming business or fully booked? Pata helps pet groomers manage appointments, take bookings online and cut
        back on admin in one simple, subscription-free booking platform.
      </p>
    </SignUpProcessTitleContainer>
  );
};

export function SignUpProcess() {
  const handleSignUpClick = () => {
    window.location.href = `${VITE_PARTNERS_BASE_URL}/sign-up`;
  };

  const handleBookDemo = () => {
    window.location.href = `https://meetings.hubspot.com/pata/demo`;
  };
  // const theme = useTheme();
  return (
    <SignUpProcessContainer>
      <Image
        src={`${VITE_CDN_BASE_URL}/images/image-app-laptop-iphone.webp`}
        alt="Pata Partners app on laptop and iPhone"
        height={2000}
        width={2000}
      />
      <WidthContainer noBackground>
        <SectionContainer title={SignUpProcessTitle}>
          <SignUpProcessContent>
            <ProcessesContainer>
              <ActionContainer>
                <Button onClick={handleSignUpClick}>Sign up today</Button>
                <Button buttonType="secondary" onClick={handleBookDemo}>
                  Book a demo
                </Button>
              </ActionContainer>
            </ProcessesContainer>
          </SignUpProcessContent>
        </SectionContainer>
      </WidthContainer>
    </SignUpProcessContainer>
  );
}
